import React from 'react';
import PropTypes from 'prop-types';
import Select from '@/modules/common/components/Select';
import '../styles/SelectLevel.scss';

const options = [
    {title: 'Отладка', value: '10'},
    {title: 'Информация', value: '20'},
    {title: 'Предупреждение', value: '30'},
    {title: 'Ошибка', value: '40'},
];

const SelectLevel = (props) => {
    return <Select className="select-level" options={options} value={props.value} onChange={props.onChange}/>;
};

SelectLevel.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default SelectLevel;
